import styled from 'styled-components'
import { Paragraph } from '../styles/Text'

export const EpicCoverageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    margin: 0;
  }
`

export const ThreeBoltsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 130px;
  margin: 40px 0;

  img {
    max-width: 300px;
    align-self: center;
  }
`

export const Tagline = styled(Paragraph)`
  align-self: center;
  text-align: center;
  margin: 0 0 13px;
  max-width: 700px;
`
